import type { SecuritySettingsFeatureConfig } from './type';

export const securitySettingsConfig: SecuritySettingsFeatureConfig = {
    oidc: false,
    alternateOidcSetup: false,
    externalClientId: '',
    externalTargets: [],
    targetTranslationMap: {},
};
